import * as S from "./style";
import axiosInstance from "../../services/axiosInstance";
import { useEffect, useState } from "react";
//Components
import TitleMenu from "../../components/Title/TitleMenu";
import Footer from "../../components/Footer";
import PopMenu from "../../components/PopMenuTable";
import Update from "../../components/Modals/Expense/Update";
import Details from "../../components/Modals/Expense/Details";
import Delete from "../../components/Modals/Delete";
import Loading from "../../components/Loading";
import useLoading from "../../hooks/useLoading";
import Auth401 from "../../components/Error/Auth";
import Erro429 from "../../components/Error/Erro429";
import TopActionBar from "../../components/TopActionBar";
// Icon
import { FiMoreVertical } from "react-icons/fi";
import { Trash, List, PencilSimple } from "@phosphor-icons/react";
// Hooks
import NoData from "../../components/NoData";
import { useMultipleModal } from "../../hooks/useMultipleModal";
import { useCheckbox } from "../../hooks/useCheckbox";
// utils
import FormatarData from "utils/FormatData";
import { CurrencyFormat } from "utils/CurrencyFormat";
// Interface
import { IExpense } from "Interfaces/IExpense";
import { IPage } from "Interfaces/IPage";

export default function Expense() {
  const [data, setData] = useState<IExpense[]>([]);
  const [openModalOptId, setOpenModalOptId] = useState<number | null>(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [page, setCurrentPage] = useState<IPage>({
    id: 0,
    last_page: 0,
    current_page: 0,
    total: 0,
  });
  const { isOpenModal, toggleModalVisibility, assignRef } = useMultipleModal();
  const { isLoading, startLoading, stopLoading } = useLoading();
  const { selectedIds, toggleCheckbox, setSelectedIds, CleanSelectIds } =
    useCheckbox();
  const [selectAll, setSelectAll] = useState(false);

  const listHeaderTable = [
    "#",
    "Nome",
    "Catergoria",
    "Valor R$",
    "Data",
    "Ações"
  ];
  const titleListPopMenu = ["Saída", "Categoria"];
  const titlePopButtton = ["expense", "category-expense"];

  const menuItemsPop = [
    { icon: <List size={16} />, title: "Detalhes", isActive: false, path: "details" },
    { icon: <PencilSimple size={16} />, title: "Editar", isActive: false, path: "update" },
    { icon: <Trash size={16} />, title: "Excluir", isActive: true, path: "delete" },
  ];

  const handleMenuClick = (path: string) => {
    toggleModalVisibility(path);
  };

  const clickPopTable = (id: number) => {
    setOpenModalOptId(id);
    toggleModalVisibility("menu");
  };

  const handleSearchChange = (term: string) => {
    setSearchTerm(term);
    fetchData();
  };

  const fetchData = async (pageNumber = 1, perPage = 10) => {
    startLoading();
    try {
      let url = `/expense?page=${pageNumber}&per_page=${perPage}`;
      if (searchTerm) {
        url += `&search=${searchTerm}`;
      }
      const response = await axiosInstance.get(url);
      setData(response.data.data);
      setCurrentPage(response.data);
    } catch (error: any) {
      if (error.status === 401) {
        toggleModalVisibility('auth');
      } else if (error.status === 429) {
        toggleModalVisibility('request429');
      }
      console.log("Error: ", error);
    } finally {
      stopLoading();
    }
  };

  useEffect(() => {
    const debounceFetch = setTimeout(() => {
      fetchData();
    }, 300);

    return () => clearTimeout(debounceFetch);
  }, [searchTerm]);

  const handleCheckChange = (id: number) => {
    toggleCheckbox(id);
  };

  const handleSelectAll = (event: React.ChangeEvent<HTMLInputElement>) => {
    const isChecked = event.target.checked;
    setSelectAll(isChecked);

    if (isChecked) {
      const newSelectedIds = new Set(data.map((item) => item.id));
      setSelectedIds(newSelectedIds);
    } else {
      CleanSelectIds();
    }
  };

  const handleDeleteResponse = (status: number) => {
    if (status === 200) {
      setSelectedIds(new Set());
      setSelectAll(false);
    }
  };

  if (isOpenModal("auth")) {
    return (
      <Auth401 isOpen={isOpenModal("auth")} />
    )
  } else if (isOpenModal("request429")) {
    return (
      <Erro429 />
    )
  }

  return (
    <S.Container>
      <TitleMenu
        title="Registro de Saídas"
        subtitle="Gerencie as saídas do sistema"
        placeholderSearch="Nome da saída"
        fetchData={fetchData}

        listPopButton={titlePopButtton}
        listPopMenu={titleListPopMenu}
        filterSearch={handleSearchChange}
        visibleButtonExport={false}
      />
      {isLoading ? (
        <Loading />
      ) : (
        <S.Content>
          <S.ContentButton>
            {selectedIds.length > 0 && (
              <TopActionBar
                idSelecteds={selectedIds}
                typeProduct="acessory"
                nameDeleteAll="expense-delete-multiple"
                fetchData={fetchData}
                handleDeleteResponse={handleDeleteResponse}
                isPromo={false}
              />
            )}
          </S.ContentButton>
          <S.Table>
            <S.THead>
              <tr>
                <th>
                  <S.CheckBox
                    type="checkbox"
                    id="deleteAll"
                    checked={selectAll}
                    onChange={(e) => handleSelectAll(e)}
                  />
                </th>
                {listHeaderTable.map((header, index) => (
                  <th key={index}>{header}</th>
                ))}
              </tr>
            </S.THead>

            <S.TBody>
              {
                data.length > 0 ? (
                  data.map((val, index) => (
                    <tr key={index}>
                      <td>
                        <S.CheckBox
                          onChange={() => handleCheckChange(val.id)}
                          type="checkbox"
                          id={val.title}
                          name={val.title}
                          checked={selectedIds.includes(val.id)}
                        />
                      </td>
                      <td>{index + 1 || '-'}</td>
                      <td>{val.title || '-'}</td>
                      <td>{val.category_expenses?.category_expense || '-'}</td>
                      <td>{CurrencyFormat(parseFloat(val.total_amount || '0'))}</td>
                      {/* <td>
                        {
                          val.proofs.length > 0 ? (
                            <S.ButtonLink>
                              Ver
                            </S.ButtonLink>
                          ) : "-"
                        }
                      </td> */}
                      <td>{FormatarData(val.date_proof, 'default') || '-'}</td>
                      <S.TdPopMenu>
                        <S.ContentPopMenu>
                          <S.ButtonTable onClick={() => clickPopTable(val.id)}>
                            <FiMoreVertical />
                          </S.ButtonTable>
                        </S.ContentPopMenu>
                        {isOpenModal("menu") && openModalOptId === val.id && (
                          <div ref={(ref) => assignRef("menu", ref)}>
                            <PopMenu menuItems={menuItemsPop} onClickTable={handleMenuClick} />
                          </div>
                        )}
                      </S.TdPopMenu>
                    </tr>
                  ))
                ) :
                  <NoData />
              }
            </S.TBody>
          </S.Table>
        </S.Content>
      )
      }

      {
        page && (
          <Footer
            fetchData={fetchData}
            currentPage={page.current_page}
            lastPage={page.last_page}
            allPerPage={page.total}
          />
        )
      }

      <Update
        isOpenModal={isOpenModal("update")}
        setModalClose={() => toggleModalVisibility("update")}
        selectedUrlId={openModalOptId}
        refreshFrames={fetchData}
      />

      <Details
        isOpenModal={isOpenModal("details")}
        setModalClose={() => toggleModalVisibility("details")}
        selectedUrlId={openModalOptId}
      />

      <Delete
        updateList={fetchData}
        endpoint="expense"
        selectedProductId={openModalOptId}
        isOpenModal={isOpenModal("delete")}
        setModalClose={() => toggleModalVisibility("delete")}
      />
    </S.Container >
  );
}
